var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u6DFB\u52A0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD9A5C",
    offset: "0.0573645105%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE6B7",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    transform: "translate(-644.000000, -883.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4",
    transform: "translate(625.000000, 864.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6DFB\\u52A0",
    transform: "translate(18.500000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,0 C19.709139,-4.05812251e-16 21.5,1.790861 21.5,4 L21.5,13.5 L31,13.5 C33.209139,13.5 35,15.290861 35,17.5 C35,19.709139 33.209139,21.5 31,21.5 L21.5,21.5 L21.5,31 C21.5,33.209139 19.709139,35 17.5,35 C15.290861,35 13.5,33.209139 13.5,31 L13.5,21.5 L4,21.5 C1.790861,21.5 0,19.709139 0,17.5 C0,15.290861 1.790861,13.5 4,13.5 L13.5,13.499 L13.5,4 C13.5,1.790861 15.290861,-4.82366169e-16 17.5,0 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon_add.f45bf87342b3e3401000d07886355e48.svg";
export { ForwardRef as ReactComponent };